import http from "./httpService";

const API_PATH = '/api/msf/1.0.0';

export const getSurveys = async ({serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/surveys`, { headers, params });

    return data;
};

export const getSurveyDetails = async ({id, serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/surveys/${id}`, { headers });

    return data;
};

export const addSurvey = async ({serviceURL, accessToken, params}) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/surveys`, params, { headers });

    return data;
};

export const updateSurvey = async ({serviceURL, accessToken, id, params}) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/surveys/${id}`, params, { headers });

    return data;
};

export const deleteSurvey = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/surveys/${id}`, { headers });

    return data;
};

export const getSurveyTypes = async ({serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/config/surveys/types`, { headers });

    return data;
};

export const applySurveyAction = async ({serviceURL, accessToken, id, params}) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/surveys/${id}/actions`, params, { headers });

    return data;
};

export const getSurveyReport = async ({serviceURL, accessToken, id}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/surveys/${id}/report`, { headers });

    return data;
};

export const downloadSurveyReport = async ({ url, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(url, { headers, responseType: "blob" });

    return data;
};

export const getQuestionnaires = async ({serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/questionnaires`, { headers, params });

    return data;
};

export const getQuestionnaireDetails = async ({id, serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/questionnaires/${id}`, { headers });

    return data;
};

export const updateQuestionnaire = async ({serviceURL, accessToken, id, params}) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/questionnaires/${id}`, params, { headers });

    return data;
};

export const getFacilitators = async ({serviceURL, accessToken}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/facilitators`, { headers });

    return data;
};

export const getRecipients = async ({serviceURL, accessToken, params}) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/recipients`, { headers, params });

    return data;
};


const msfService = {
    getSurveys,
    getSurveyDetails,
    addSurvey,
    updateSurvey,
    deleteSurvey,
    applySurveyAction,
    getSurveyTypes,
    getSurveyReport,
    downloadSurveyReport,
    getQuestionnaires,
    getQuestionnaireDetails,
    updateQuestionnaire,
    getFacilitators,
    getRecipients
};

export default msfService;
